import apiFetcher, { apiFetcherArgs, ResponseError } from '@/api/apiFetcher';
import useSWR from 'swr';

export default function useApi<T = any>(
  args: apiFetcherArgs
): [T | undefined, ResponseError | undefined, boolean] {
  const { data, error, isLoading } = useSWR<T, Error, apiFetcherArgs>(
    args,
    apiFetcher
  );

  return [data, error, isLoading];
}
